import { gql } from '@apollo/client';

export const EXPORT_FUNDER_SERVICE_PROVIDERS = gql`
  query ExportFunderServiceProviders($input: ExportArgs!) {
    exportFunderServiceProviders(input: $input) {
      id
      legalStructure
      roles
      type
      address
      contactNumber
      description
      legalStructure
      email
      execInCharge
      firstContactPerson
      firstContactPersonEmail
      firstContactPersonNumber
      logo
      name
      orgLeader
      physicalAddress
      registrationNumber
      secondContactPerson
      secondContactPersonEmail
      secondContactPersonNumber
      title
      website
      programmes {
        id
        name
      }
    }
  }
`;
